import { render, staticRenderFns } from "./contractsChart.vue?vue&type=template&id=a9e0bf52&scoped=true"
import script from "./contractsChart.vue?vue&type=script&lang=js"
export * from "./contractsChart.vue?vue&type=script&lang=js"
import style0 from "./contractsChart.vue?vue&type=style&index=0&id=a9e0bf52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e0bf52",
  null
  
)

export default component.exports